module.exports = __webpack_public_path__ + "img/Evaluation Process_Tier 1_Page_3.1fb735f1.jpg";